module.exports = __webpack_public_path__ + "img/home-hero_en-4.2166728.jpg";